import React from 'react';

export const InstrumentsInHand = ({ data }) => {
    // Debug: Track when props change
    React.useEffect(() => {
        if (data?.summary?.total_cheques_in_system !== undefined) {
            // console.log('💳 InstrumentsInHand received updated data - cheque value:', 
            //     data.summary.total_cheques_in_system);
        }
    }, [data]);

    if (!data) {
        return (
            <div className="section-card">
                <h2>Instruments in Hand</h2>
                <div className="loading-placeholder">Loading...</div>
            </div>
        );
    }

    const { summary, employees_instruments } = data;

    // Add null checks for nested properties
    if (!summary) {
        return (
            <div className="section-card">
                <h2>Instruments in Hand</h2>
                <div className="loading-placeholder">Loading data...</div>
            </div>
        );
    }

    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'INR',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }).format(amount);
    };

    return (
        <div className="section-card">
            <div className="section-header">
                <h2>Instruments in Hand</h2>
                <div className="summary-stats">
                    <span className="stat-item">
                        <strong>Total Value: {formatCurrency(summary.total_instruments_value || 0)}</strong>
                    </span>
                    <span className="stat-item">
                        Employees: {summary.total_employees || 0}
                    </span>
                </div>
            </div>

            <div className="instruments-summary">
                <div className="summary-cards">
                    <div className="summary-card cash">
                        <div className="card-icon">💵</div>
                        <div className="card-content">
                            <h3>Cash in Hand</h3>
                            <p className="amount">{formatCurrency(summary.total_cash_in_system || 0)}</p>
                        </div>
                    </div>
                    <div className="summary-card cheque">
                        <div className="card-icon">📄</div>
                        <div className="card-content">
                            <h3>Cheques</h3>
                            <p className="amount">{formatCurrency(summary.total_cheques_in_system || 0)}</p>
                        </div>
                    </div>
                    <div className="summary-card dd">
                        <div className="card-icon">🏦</div>
                        <div className="card-content">
                            <h3>Demand Drafts</h3>
                            <p className="amount">{formatCurrency(summary.total_dd_in_system || 0)}</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="employees-instruments">
                <h3>Employee-wise Breakdown</h3>
                <div className="instruments-table">
                    <table>
                        <thead>
                            <tr>
                                <th>Employee</th>
                                <th>Department</th>
                                <th>Cash</th>
                                <th>Cheques</th>
                                <th>DD</th>
                                <th>Total</th>
                                <th>Contact</th>
                            </tr>
                        </thead>
                        <tbody>
                            {(employees_instruments || []).map((emp) => {
                                const empInfo = emp.employee_info || {};
                                const instruments = emp.instruments_in_hand || {};
                                const detailed = emp.detailed_instruments || {};
                                
                                return (
                                <tr key={emp.user_id}>
                                    <td>
                                        <div className="employee-info">
                                            <strong>{empInfo.name || 'N/A'}</strong>
                                            <small>({empInfo.unique_code || 'N/A'})</small>
                                        </div>
                                    </td>
                                    <td>{empInfo.department || 'N/A'}</td>
                                    <td className="amount-cell cash">
                                        {formatCurrency(instruments.cash_in_hand || 0)}
                                    </td>
                                    <td className="amount-cell cheque">
                                        {formatCurrency(instruments.cheques_in_hand || 0)}
                                        {(detailed.cheques_count || 0) > 0 && (
                                            <small> ({detailed.cheques_count})</small>
                                        )}
                                    </td>
                                    <td className="amount-cell dd">
                                        {formatCurrency(instruments.dd_in_hand || 0)}
                                        {(detailed.dd_count || 0) > 0 && (
                                            <small> ({detailed.dd_count})</small>
                                        )}
                                    </td>
                                    <td className="amount-cell total">
                                        <strong>{formatCurrency(instruments.total_amount || 0)}</strong>
                                    </td>
                                    <td>
                                        <small>{empInfo.mobile || 'N/A'}</small>
                                    </td>
                                </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};
